import staticQueryData from "../../public/static/d/3466987116.json";
export var useSettingsData = function useSettingsData() {
  var _queryData$prismicSet;

  var queryData = staticQueryData.data;
  return (_queryData$prismicSet = queryData.prismicSettings) === null || _queryData$prismicSet === void 0 ? void 0 : _queryData$prismicSet.data;
};